import { cva } from "class-variance-authority";
import { cn } from "../../../@shadcn/lib/utils";

export interface AppsGridProps {
  items: string[];
  className?: string;
}

const GRID_SIZE = 4;

const appsGridVariants = cva(
  "ui-grid ui-grid-cols-2 ui-grid-rows-2 ui-gap-0.5 ui-h-10 ui-w-10 ui-overflow-hidden",
);

export const AppsGrid: React.FC<AppsGridProps> = ({
  items,
  className = "",
}) => {
  const visibleItems = items.slice(0, GRID_SIZE);

  return (
    <div className={cn(appsGridVariants(), className)}>
      {Array.from({ length: GRID_SIZE }, (_, index) => visibleItems[index]).map(
        (url, index) =>
          url ? (
            <img
              key={index}
              src={url}
              alt=""
              className="ui-h-full ui-w-full ui-object-cover ui-rounded-sm"
            />
          ) : (
            <div
              key={index}
              className="ui-h-full ui-w-full ui-bg-zinc-300/70 ui-rounded-sm"
            />
          ),
      )}
    </div>
  );
};
